<template>
	<div class="ReInputRoomSum">
		<!-- <base-input
			v-model="bufferValue"
			type="text"
			:name="errorLabel"
			:error="getError(errorLabel)"
			:placeholder="placeholder"
			v-validate="{snils:true}"
		></base-input> -->
		<div class="roomsum_container">
			<base-input
			v-model="value.textval"
			:placeholder="placeholder"
			@change="getSum(value.textval)"
			
			></base-input>
			<!-- <base-input
			v-model.lazy="bufferValue"
			class=""
			:placeholder="placeholder"
			@change="bufferValue.roomSum"
			@keyup="getSum(bufferValue)"
			@blur="getSum(bufferValue)"
			></base-input> -->
			<span class="text-primary">Сумма площадей комнат: {{ this.value.roomSum }}</span>
		</div>
		<base-button class="my-0 btn btn-simple btn-primary" @click="getSum(value.textval)">Суммировать</base-button>
		
		<el-popover
			placement="bottom"
			title="Пример заполнения"
			width="350"
			trigger="hover"
			content="">
			<i class="tim-icons text-primary icon-alert-circle-exc ml-2" slot="reference" style="font-size:18px; margin-top: 10px;"></i>
			<div>Для объекта "Комната" укажите только значения площадей продаваемых комнат</div>
			<div>Комнаты изолированные: 12+19 </div>
			<div>Комнаты смежные: (13+14) </div>
			<div class="mb-2">Комнаты смежно-изолированные: (13+14)+17</div>
			<div class="btnovertext text-primary">Кнопка "Суммировать" подставит сумму комнат в поле "Жилая площадь"</div>
			<!-- <el-button slot="reference">Hover to activate</el-button> -->
		</el-popover>
	</div>
</template>

<script>
	import { Button, Popover } from 'element-ui';

	export default {
		name: 'ReInputRoomSum',
		components: {
			[Button.name]: Button,
			[Popover.name]: Popover,
		},
		props: {
			value:{
				type: Object,
				default(){
					return {
						textval: '',
						roomSum: '',
					}
				}
			},
			
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			placeholder: {
				type: String,
				default: 'Например: 12+14+13+(10+11)',
			},
		},
		data () {
			return {
				ver: 1,
				// bufferValue:{textval: '',roomSum: '',},
				bufferArrRoomSum: [],
				// bufferRoomSum: '',
				
			}
		},
		watch:{
			value:{
				handler(value){
					this.$emit('input', value);
				},
				deep: true,
			}
		},
		computed: {

		},
		methods: {
			getSum(values){
				if(this.value.textval!=''){
					this.bufferArrRoomSum = this.$GVO.str_replace(/[{()}]/g,'',values).replaceAll(',','.').split('+').map(x => parseFloat(x));

					// let tmpRoomSum = this.$GVO.str_replace(/[{()}]/g,'',values).replaceAll(',','.').split('+'); //.map(x => parseFloat(x).toFixed(2));
					// let dataSum = 0.0;
					// for (let i=0; i < this.bufferArrRoomSum.length; i++) {
					// 	dataSum += parseFloat(this.bufferArrRoomSum[i]);
					// }
					// dataSum = dataSum.toFixed(2);
					// console.log('this.bufferArrRoomSum',this.bufferArrRoomSum);
					// console.log('dataSum',dataSum);


					// this.bufferArrRoomSum = values.replaceAll(/[{()}]/g, '').split('+').map(x => parseInt(x, 10)); //удалим все скобки и сделаем массив чисел // parseFloat? parseInt?
					

					// let lastElement = this.bufferArrRoomSum[this.bufferArrRoomSum.length - 1];
					let lastElement = this.bufferArrRoomSum.slice(-1); // если в последнем эелемент какая-то фигня типо +, а не число
					
					if(!isNaN(lastElement)){
						this.value.roomSum = this.bufferArrRoomSum.reduce((a, b) => a + b, 0);
						// console.log('this.bufferArrRoomSum0',this.bufferArrRoomSum);
					} else {
						// console.log('this.bufferArrRoomSum1',this.bufferArrRoomSum);
						this.bufferArrRoomSum.splice(-1,1); 
						// console.log('this.bufferArrRoomSum2',this.bufferArrRoomSum);
						this.value.roomSum = this.bufferArrRoomSum.reduce((a, b) => a + b, 0);
						
					}
					this.value.roomSum = this.value.roomSum.toFixed(2);
				}else {this.bufferArrRoomSum = []; this.value.roomSum ='';}
			},
			
			
		},
		mounted() {
		
		}
	}
</script>
<style scoped>
.ReInputRoomSum {display: inline-flex; align-items:flex-start;}
.roomsum_container {display: flex; flex-direction: column; margin-right: 5px;}
.btnovertext {white-space: normal!important; word-break: break-word!important;}
</style>
